import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import router from './router';
import './assets/styles.css';
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import {useLogger} from "./composables/useLogger"
import {usePathController} from "./composables/usePathController"

const {sendLog, sendCriticalError} = useLogger()

const app = createApp(App);
const pinia = createPinia();
const vuetify = createVuetify({
    components:{
        VFileUpload,
        ...components
    }, directives,
    icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})

app.config.errorHandler = (error, instance, info) => {

  sendLog("error", 'Vue error caught', {
    error: error.message,
    stack: error.stack,
    component: instance?.$options.name,
    info
  })
}

window.addEventListener('unhandledrejection', event => {
  sendLog("error", "Unhandled promise rejection", {
    reason: event.reason,
    promise: event.promise
  })
  sendCriticalError(event, {
    event: "unhandled_promise_rejection"
})
})

window.addEventListener('error', event => {
  sendLog("javascript error", {
    error: event.error,
    type: 'javascriptError',
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno
  });
});

app.use(pinia);
await usePathController().initAuth()

app.use(router);
app.use(vuetify);
app.mount('#app');
app.provide('logger', sendLog);